import { CircularProgress } from '@mui/material';
import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { useAppSelector } from '../../../app/hooks';
import useMountTransition from '../../../utils/useMountTransition';
import classes from './LoadingProvider.module.scss';

interface LoadingProviderProps {
  transitionDuration?: number;
  loading?: boolean;
  children?: ReactNode;
}

const LoadingProvider: FC<LoadingProviderProps> = ({
  transitionDuration = 300,
  loading: forceLoading,
  children,
}) => {
  const loading = useAppSelector((state) => state.global.globalLoading);

  const shouldRender = useMountTransition(
    forceLoading || loading,
    transitionDuration
  );

  return (
    <>
      {children}
      {(shouldRender || loading) &&
        createPortal(
          <div
            style={{ transitionDuration: `${transitionDuration}ms` }}
            className={classNames({
              [classes.Backdrop]: true,
              [classes.BackdropAnimateIn]:
                (loading || forceLoading) && shouldRender,
            })}
          >
            <CircularProgress color="primary" />
          </div>,
          document.body
        )}
    </>
  );
};

export default LoadingProvider;
